import { EnvFeatureService } from '@/core/env/env.service';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

export const apiBaseInterceptor: HttpInterceptorFn = (request, next) => {
  // Alterei o código para usar o serviço EnvFeatureService diretamente, em vez de depender dos arquivos de ambiente.
  // Isso permite que usemos as variáveis de ambiente definidas no arquivo env.js, que é carregado dinamicamente no navegador
  // e lê estas diretamente do GCP, sem precisar recompilar a aplicação para cada ambiente.
  const env = inject(EnvFeatureService);

  if (request.url.startsWith('/i18n/')) return next(request);
  if (/^https?:\/\//.test(request.url)) return next(request);
  const url = `${env.apiBaseUrl}${request.url.startsWith('/') ? '' : '/'}${request.url}`;
  return next(request.clone({ url }));
};
